import { ConfirmDialog } from '@/shared/ui/confirm-dialog'
import { toast } from '@/shared/ui/toast'
import { useDeleteMeeting } from '../api/edit'

interface DeleteMeetingDialogProps {
  meeting: { id: string; title: string }
  open: boolean
  onClose: () => void
  /** Куда уйти после удаления (со страницы встречи — в ленту). */
  onDeleted?: () => void
}

export function DeleteMeetingDialog({
  meeting,
  open,
  onClose,
  onDeleted,
}: DeleteMeetingDialogProps) {
  const del = useDeleteMeeting(meeting.id)
  return (
    <ConfirmDialog
      open={open}
      title="Удалить встречу?"
      confirmLabel="Удалить"
      pending={del.isPending}
      onClose={onClose}
      onConfirm={() =>
        del.mutate(undefined, {
          onSuccess: () => {
            toast.success('Встреча удалена')
            onClose()
            onDeleted?.()
          },
          onError: () => toast.error('Не удалось удалить встречу'),
        })
      }
    >
      «{meeting.title}» и всё, что к ней прикреплено — заметки, вложения, документы и обсуждение —
      удалится без возврата.
    </ConfirmDialog>
  )
}
